import request from '@/utils/request'

const NEWS_MODULE_ID = 'c1e5601c-5974-46f7-b27f-b0ce8b7f892a'

/**
 * 新闻接口返回的正文图片是相对路径 ./df/xxx，
 * 展示时需要补上 /portal 前缀才能正常加载。
 */
function normalizeImages(item) {
  const titlePic = item?.titPicList?.[0]?.titPicUrl
  return {
    ...item,
    titlePicUrl: titlePic?.replace(/(\.\/df)/g, '/portal/r/df'),
  }
}

/** 列表：size 为每页条数，start 为页码 */
export async function fetchNewsList({ size = 8, start = 1 } = {}) {
  const res = await request.post('/portal/r/m/msg/list', {
    size,
    start,
    moduleId: NEWS_MODULE_ID,
  })
  const data = res.data?.data
  if (res.data?.result !== 'ok' || !data) throw new Error('返回数据格式异常')
  return {
    list: (data.messageList || []).map(normalizeImages),
    total: data.counts || 0,
  }
}

/** 详情 */
export async function fetchNewsDetail(id) {
  const res = await request.post('/portal/r/m/msg/detail', { id })
  const data = res.data?.data
  if (res.data?.result !== 'ok' || !data) throw new Error('返回数据格式异常')
  return normalizeImages(data)
}

/* ============================================================
   本地兜底
   —— 后台接口未接入、且暂无真实新闻数据时，列表保持为空态。
      如需演示数据，请在此处补入公司真实发布过的内容，勿使用编造内容。
   ============================================================ */
const MOCK_LIST = []

/** 带兜底的列表接口 */
export async function fetchNewsListSafe(options) {
  try {
    return { ...(await fetchNewsList(options)), fallback: false }
  } catch {
    const { size = 8, start = 1 } = options || {}
    const offset = (start - 1) * size
    return {
      list: MOCK_LIST.slice(offset, offset + size),
      total: MOCK_LIST.length,
      fallback: true,
    }
  }
}

export async function fetchNewsDetailSafe(id) {
  try {
    return { ...(await fetchNewsDetail(id)), fallback: false }
  } catch {
    return { ...(MOCK_LIST.find((n) => n.id === id) || MOCK_LIST[0]), fallback: true }
  }
}